// Take a Parse.Object, return a plain {}
export default function parseObjectToJs (obj) {
  if (Array.isArray(obj)) return obj.map(parseObjectToJs)

  return walkObjectAndApply(obj.toJSON(), (parent, child, key) => {
    // Taking serialized Parse date and returning a Date
    if (child && child.__type === 'Date' && child.iso) {
      parent[key] = new Date(child.iso)
    }

    if (parent.objectId) {
      parent.id = parent.objectId
      parent.objectId = undefined
    }
  })
}

// basically a breadth-first scan
function walkObjectAndApply (obj, mutator) {
  if (typeof obj !== 'object' || obj === null) return obj

  const keys = Object.keys(obj)
  keys.forEach(key => {
    mutator(obj, obj[key], key)
  })
  keys.forEach(key => {
    walkObjectAndApply(obj[key], mutator)
  })

  return obj
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/modules/parse-object-to-js.js